import { useGrowl } from "PFApp/use_growl";
import ConfirmModal, { ConfirmModalHeader } from "PFComponents/confirm/confirm_modal";
import { InputFieldSet } from "PFComponents/text/input_field_set";
import { useGenerateReport } from "PFCore/hooks/queries/bookings/booking_export/use_generate_report";
import React, { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { useExportWizardModalContext } from "../../../../export_wizard_modal_provider";
import { useGeneratePayloadProvider } from "../use_generate_payload_provider";
import css from "./report_name_modal.module.scss";

export const ReportNameModal = (): JSX.Element => {
  const growl = useGrowl();
  const { close, updateData } = useExportWizardModalContext();
  const { t: defaultT } = useTranslation("translation");
  const { t } = useTranslation("bookingModule", { keyPrefix: "reports.exportWizard" });
  const [value, setValue] = useState<string>("");
  const provideGeneratePayload = useGeneratePayloadProvider();

  const { mutateAsync: generateReport, isLoading } = useGenerateReport({
    onSuccess: () => {
      growl({
        kind: "success",
        message: (
          <Trans
            i18nKey="generateSuccess"
            t={t}
            components={[<Link className={css.link} to="/booking/reports?manageReports=true" key="0" />]}
          />
        )
      });
    },
    onError: () => {
      growl({
        kind: "error",
        message: t("generateFailed")
      });
    }
  });

  const handleOK = async () => {
    const payload = provideGeneratePayload(value);
    await generateReport(payload);
    close();
  };

  const handleClose = () => {
    updateData({ modals: { reportNameOpen: false } });
  };

  return (
    <ConfirmModal
      handleOK={value && !isLoading ? handleOK : undefined}
      labelOK={defaultT("save")}
      handleClose={handleClose}
    >
      <ConfirmModalHeader className={css.header}>{t("nameOfReportModalTitle")}</ConfirmModalHeader>
      <InputFieldSet
        label={t("reportName")}
        value={value}
        required
        className={css.inputRoot}
        onChange={(value) => setValue(value)}
        maxLength={100}
      />
    </ConfirmModal>
  );
};
